/**
 * @file Component representing the footer of the application.
 * @author Tom Verschoore de la Houssaije
 */
import { OverlayService } from '../../core/overlay.service';
import { SettingsService } from '../../settings.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { TestService } from '../../test.service';
/**
 * Component representing the footer of the application.
 */
var VersionInfoComponent = /** @class */ (function () {
    /**
     * Constructs the footer of the application.
     * @param translateService The translate service to support multi language.
     * @param overlayService The overlay service.
     * @param settingsService The settings service.
     */
    function VersionInfoComponent(overlayService, settingsService, testService, localStorageService) {
        this.overlayService = overlayService;
        this.settingsService = settingsService;
        this.testService = testService;
        this.localStorageService = localStorageService;
    }
    VersionInfoComponent.prototype.close = function () {
        this.overlayService.closeOverlay();
    };
    return VersionInfoComponent;
}());
export { VersionInfoComponent };
